var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.197 15.362a2.5 2.5 0 0 1-2.395 0L2 10.56v7.607a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5V10.56l-8.803 4.802Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14a.832.832 0 0 1-.398-.102l-9.167-5A.833.833 0 0 1 2 8.167V6.5A2.5 2.5 0 0 1 4.5 4h15A2.5 2.5 0 0 1 22 6.5v1.667a.834.834 0 0 1-.435.731l-9.167 5A.832.832 0 0 1 12 14Z",
    fill: "currentColor"
  })));
};

export { SvgEmail as ReactComponent };
export default __webpack_public_path__ + "a5973f2df73655ddb897918b355088aa.svg";